module.exports = __webpack_public_path__ + "static/media/team-personality-empty.f49ac635.jpg";